// extracted by mini-css-extract-plugin
export var actionsRow = "_k-a";
export var actionsRowEnd = "_k-b";
export var askRedoBlackBtn = "_k-d";
export var askRedoBlackBtnIcon = "_k-e";
export var exitModalActionBtn = "_k-c";
export var exitModalRoot = "_k-0";
export var followUpInput = "_k-9";
export var modalContentBody = "_k-7";
export var modalHeaderImage = "_k-2";
export var modalImageLabel = "_k-4";
export var modalImageOverlay = "_k-3";
export var modalImageSubheading = "_k-6";
export var modalImageTitle = "_k-5";
export var modalImageWrapper = "_k-1";
export var reasonCard = "_k-f";
export var reasonCardSelected = "_k-g";
export var reasonIcon = "_k-j";
export var reasonIconWrap = "_k-i";
export var reasonIndicator = "_k-l";
export var reasonIndicatorDot = "_k-n";
export var reasonIndicatorSelected = "_k-m";
export var reasonLabel = "_k-h";
export var reasonList = "_k-8";
export var reasonTitle = "_k-k";